import { gql } from 'urql';

export const ATENCION_DASHBOARD = gql`
  query AtencionDashboard($desde: String, $hasta: String) {
    atencionDashboard(desde: $desde, hasta: $hasta) {
      reclamosAbiertos
      mttaPromedio
      mttrPromedio
      slaCumplido
      topCategorias {
        categoria
        cantidad
      }
      ticketsPorCliente {
        clienteId
        cantidad
      }
    }
  }
`;
